import * as tslib_1 from "tslib";
import './icon.less';
import { m } from '../hyperscript';
import { addClasses } from '../util/classes';
import { View } from './view';
var Icon = /** @class */ (function (_super) {
    tslib_1.__extends(Icon, _super);
    function Icon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Icon.prototype.render = function () {
        var _a = this.attrs, children = _a.children, icon = _a.icon, attrs = tslib_1.__rest(_a, ["children", "icon"]);
        return m('i.icon', addClasses(attrs, { icon: icon }));
    };
    return Icon;
}(View));
export { Icon };
